<template>
  <ModalLayer
    :isOpen="isOpen"
    :type="type"
    :renderType="renderType"
    :title="title"
    :message="message"
    :subMessage="subMessage"
    :onOK="onOK"
    :onCancel="onCancel"
    :params="onParams"
  />
</template>

<script>
import ModalLayer from '@/presentationals/v2/components/layouts/templates/ModalLayer'

export default {
  name: 'ModalLayerContainer',
  components: {
    ModalLayer
  },
  computed: {
    title() {
      return this.$store.getters['modal/title']
    },
    message() {
      return this.$store.getters['modal/message']
    },
    subMessage() {
      return this.$store.getters['modal/subMessage']
    },
    type() {
      return this.$store.getters['modal/type']
    },
    renderType() {
      return this.$store.getters['modal/renderType']
    },
    isOpen() {
      return this.$store.getters['modal/isOpen']
    },
    onOK() {
      return this.$store.getters['modal/functions'].onOK
    },
    onCancel() {
      return this.$store.getters['modal/functions'].onCancel
    },
    onParams() {
      return this.$store.getters['modal/params']
    }
  }
}
</script>